import React from 'react';
import ScholarAI from './ScholarAI';
import './App.css';

function App() {
  return (
    <div className="App">
      <ScholarAI />
    </div>
  );
}

export default App;
